import { useEffect } from 'react';

import { APP_TITLE } from '../../const/appTitle';

type UseDocumentTitleParams = {
	documentTitle?: string;
};

export const useDocumentTitle = ({
	documentTitle,
}: UseDocumentTitleParams = {}) => {
	useEffect(() => {
		const nextTitle = documentTitle ?? APP_TITLE;
		const isTitleUpdateNeeded = document.title !== nextTitle;

		if (isTitleUpdateNeeded) {
			document.title = nextTitle;
		}
	}, [documentTitle]);
};
